import i18n from "@/i18n";
import { LabTestStatus } from "./LabTestStatus";

export enum AbortReason {
  EquipmentFailure = "EquipmentFailure",
  CancelledByClient = "CancelledByClient",
  ResultNotRepresentative = "ResultNotRepresentative",
  UnableToFinishAcquisition = "UnableToFinishAcquisition",
  NotEnoughOfMaterial = "NotEnoughOfMaterial",
  MaterialNotSuitable = "MaterialNotSuitable",
  Other = "Other",
  // Synthetic — set server-side when an approver sends a test back for retesting.
  // Never user-selectable: omitted from all availableReasons lists.
  SentBackByApprover = "SentBackByApprover",
}

export const getAbortReasonLabels = (): Record<AbortReason, string> => ({
  [AbortReason.EquipmentFailure]: i18n.t("common:abortReason.equipmentFailure"),
  [AbortReason.CancelledByClient]: i18n.t("common:abortReason.cancelledByClient"),
  [AbortReason.ResultNotRepresentative]: i18n.t("common:abortReason.resultNotRepresentative"),
  [AbortReason.UnableToFinishAcquisition]: i18n.t("common:abortReason.unableToFinishAcquisition"),
  [AbortReason.NotEnoughOfMaterial]: i18n.t("common:abortReason.notEnoughOfMaterial"),
  [AbortReason.MaterialNotSuitable]: i18n.t("common:abortReason.materialNotSuitable"),
  [AbortReason.Other]: i18n.t("common:abortReason.other"),
  [AbortReason.SentBackByApprover]: i18n.t("common:abortReason.sentBackByApprover"),
});

export interface AbortReasonConfig {
  availableReasons: AbortReason[];
  reasonsRequiringConfirmation: AbortReason[];
}

const ABORT_CONFIG_READY_FOR_TESTING: AbortReasonConfig = {
  availableReasons: [
    AbortReason.NotEnoughOfMaterial,
    AbortReason.MaterialNotSuitable,
    AbortReason.CancelledByClient,
    AbortReason.Other,
  ],
  reasonsRequiringConfirmation: [AbortReason.NotEnoughOfMaterial, AbortReason.MaterialNotSuitable, AbortReason.Other],
};

const ABORT_CONFIG_IN_TESTING: AbortReasonConfig = {
  availableReasons: [
    AbortReason.EquipmentFailure,
    AbortReason.CancelledByClient,
    AbortReason.UnableToFinishAcquisition,
    AbortReason.Other,
  ],
  reasonsRequiringConfirmation: [
    AbortReason.EquipmentFailure,
    AbortReason.UnableToFinishAcquisition,
    AbortReason.Other,
  ],
};

export const getAbortConfigForStatus = (status: LabTestStatus): AbortReasonConfig =>
  status === LabTestStatus.InTesting ? ABORT_CONFIG_IN_TESTING : ABORT_CONFIG_READY_FOR_TESTING;
